export default "__VITE_ASSET__D7o0s$$X__"